import { CurrentUnit, SpeedUnit, TorqueUnit } from '../enums';

export const ABSOLUTE_UNITS = { torqueUnit: TorqueUnit.Nm, speedUnit: SpeedUnit.Rpm, currentUnit: CurrentUnit.A };

export const RELATED_UNITS = { torqueUnit: TorqueUnit.MMn, speedUnit: SpeedUnit.NNsyn, currentUnit: CurrentUnit.IIn };
